import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "SAML SSO를 이제 사용할 수 있습니다",
  "description": "WorkOS 덕분에 SAML Single Sign-on(SSO)을 이제 엔터프라이즈 고객이 사용할 수 있습니다.",
  "date": "2021/08/03",
  "tag": "web development",
  "ogImage": "/images/blog/saml-sso-now-available/x-card.png"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "WorkOS 덕분에 GitHub, GitLab, 비밀번호 없는 인증 외에도 Turborepo는 이제 엔터프라이즈 고객을 위해 다음 SAML 제공업체의 Single Sign-on(SSO)을 지원합니다:"
  }, {
    "heading": "",
    "content": "AD FS SAML"
  }, {
    "heading": "",
    "content": "Auth0 SAML"
  }, {
    "heading": "",
    "content": "Azure AD SAML"
  }, {
    "heading": "",
    "content": "CyberArk SAML"
  }, {
    "heading": "",
    "content": "Generic SAML"
  }, {
    "heading": "",
    "content": "G Suite OAuth"
  }, {
    "heading": "",
    "content": "G Suite SAML"
  }, {
    "heading": "",
    "content": "JumpCloud SAML"
  }, {
    "heading": "",
    "content": "Microsoft OAuth"
  }, {
    "heading": "",
    "content": "Okta SAML"
  }, {
    "heading": "",
    "content": "OneLogin SAML"
  }, {
    "heading": "",
    "content": "OpenID Connect"
  }, {
    "heading": "",
    "content": "PingFederate SAML"
  }, {
    "heading": "",
    "content": "PingOne SAML"
  }, {
    "heading": "",
    "content": "Shibboleth"
  }, {
    "heading": "",
    "content": "VMWare SAML"
  }, {
    "heading": "",
    "content": "또한 다음을 통해 SCIM(일명 \"디렉터리 동기화\")을 지원합니다:"
  }, {
    "heading": "",
    "content": "Azure AD SCIM"
  }, {
    "heading": "",
    "content": "BambooHR"
  }, {
    "heading": "",
    "content": "G Suite"
  }, {
    "heading": "",
    "content": "Gusto"
  }, {
    "heading": "",
    "content": "Hibob"
  }, {
    "heading": "",
    "content": "Okta SCIM v1.1"
  }, {
    "heading": "",
    "content": "Okta SCIM v2.0"
  }, {
    "heading": "",
    "content": "Rippling"
  }, {
    "heading": "",
    "content": "SCIM v1.1"
  }, {
    "heading": "",
    "content": "SCIM v2.0"
  }, {
    "heading": "",
    "content": "Workday"
  }, {
    "heading": "",
    "content": "귀하의 팀이 SAML SSO 활성화에 관심이 있으시면 turborepo@vercel.com으로 문의해 주세요."
  }, {
    "heading": "다음은-무엇인가요",
    "content": "우리는 보안을 매우 중요하게 생각합니다. SSO가 2021년에 필수적인 것은 분명하지만, 현재 제3자 SOC 2 Type 2 검사도 진행 중입니다. 마지막으로 올 가을에 생체 인식/U2F 액세스 제어 및 감사 로그를 추가하고 있습니다. 업데이트를 기대해 주세요."
  }],
  "headings": [{
    "id": "다음은-무엇인가요",
    "content": "다음은 무엇인가요?"
  }]
};
import {Authors} from '#components/authors';
export const toc = [{
  depth: 2,
  url: "#다음은-무엇인가요",
  title: _jsx(_Fragment, {
    children: "다음은 무엇인가요?"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    li: "li",
    p: "p",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "SAML SSO를 이제 사용할 수 있습니다"
    }), "\n", "\n", _jsx(Authors, {
      authors: ['jaredpalmer']
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://workos.com/",
        children: "WorkOS"
      }), " 덕분에 GitHub, GitLab, 비밀번호 없는 인증 외에도 Turborepo는 이제 엔터프라이즈 고객을 위해 다음 SAML 제공업체의 Single Sign-on(SSO)을 지원합니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "AD FS SAML"
      }), "\n", _jsx(_components.li, {
        children: "Auth0 SAML"
      }), "\n", _jsx(_components.li, {
        children: "Azure AD SAML"
      }), "\n", _jsx(_components.li, {
        children: "CyberArk SAML"
      }), "\n", _jsx(_components.li, {
        children: "Generic SAML"
      }), "\n", _jsx(_components.li, {
        children: "G Suite OAuth"
      }), "\n", _jsx(_components.li, {
        children: "G Suite SAML"
      }), "\n", _jsx(_components.li, {
        children: "JumpCloud SAML"
      }), "\n", _jsx(_components.li, {
        children: "Microsoft OAuth"
      }), "\n", _jsx(_components.li, {
        children: "Okta SAML"
      }), "\n", _jsx(_components.li, {
        children: "OneLogin SAML"
      }), "\n", _jsx(_components.li, {
        children: "OpenID Connect"
      }), "\n", _jsx(_components.li, {
        children: "PingFederate SAML"
      }), "\n", _jsx(_components.li, {
        children: "PingOne SAML"
      }), "\n", _jsx(_components.li, {
        children: "Shibboleth"
      }), "\n", _jsx(_components.li, {
        children: "VMWare SAML"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "또한 다음을 통해 SCIM(일명 \"디렉터리 동기화\")을 지원합니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Azure AD SCIM"
      }), "\n", _jsx(_components.li, {
        children: "BambooHR"
      }), "\n", _jsx(_components.li, {
        children: "G Suite"
      }), "\n", _jsx(_components.li, {
        children: "Gusto"
      }), "\n", _jsx(_components.li, {
        children: "Hibob"
      }), "\n", _jsx(_components.li, {
        children: "Okta SCIM v1.1"
      }), "\n", _jsx(_components.li, {
        children: "Okta SCIM v2.0"
      }), "\n", _jsx(_components.li, {
        children: "Rippling"
      }), "\n", _jsx(_components.li, {
        children: "SCIM v1.1"
      }), "\n", _jsx(_components.li, {
        children: "SCIM v2.0"
      }), "\n", _jsx(_components.li, {
        children: "Workday"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["귀하의 팀이 SAML SSO 활성화에 관심이 있으시면 ", _jsx(_components.a, {
        href: "mailto:turborepo@vercel.com",
        children: "turborepo@vercel.com"
      }), "으로 문의해 주세요."]
    }), "\n", _jsx(_components.h2, {
      id: "다음은-무엇인가요",
      children: "다음은 무엇인가요?"
    }), "\n", _jsx(_components.p, {
      children: "우리는 보안을 매우 중요하게 생각합니다. SSO가 2021년에 필수적인 것은 분명하지만, 현재 제3자 SOC 2 Type 2 검사도 진행 중입니다. 마지막으로 올 가을에 생체 인식/U2F 액세스 제어 및 감사 로그를 추가하고 있습니다. 업데이트를 기대해 주세요."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
